import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DirectLoginApp } from "~/apps/DirectLoginApp";
import { initSentry } from "~/lib/sentry";

initSentry();

const root = createRoot(document.getElementById("react")!);

root.render(
  <StrictMode>
    <DirectLoginApp />
  </StrictMode>,
);
